var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.project.selected)?_c('ProjectItem',{attrs:{"projectData":_vm.$store.state.project.selected}}):_c('div',{staticClass:"caption"},[(_vm.$store.state.project?.projects?.length<0 &! _vm.$store.state.loading.loadingState)?_c('p',{staticClass:"mx-auto"},[_vm._v("Sie haben keine Projekte")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }